<picture>
  <source srcset="/assets/taustat/login_720x512_crushed.webp 720w, /assets/taustat/login_1440x1024_crushed.webp 1440w, /assets/taustat/login_2880x2048_crushed.webp 2880w, /assets/taustat/login_4320x3072_crushed.webp 4320w" type="image/webp" sizes="100vw" />
  <source srcset="/assets/taustat/login_720x512_crushed.png 720w, /assets/taustat/login_1440x1024_crushed.png 1440w, /assets/taustat/login_2880x2048_crushed.png 2880w, /assets/taustat/login_4320x3072_crushed.png 4320w" type="image/png" sizes="100vw" />
  <img src="/assets/taustat/login_720x512_crushed.png" class="tausta" />
</picture>

<div class="all-container">
  <div class="login-container">
    <div class="mat-elevation-z3" style="line-height: 24px; padding: 10px; background-color: rgba(255, 255, 255, 1); border-radius: 10px; margin: 10px">
      @if (!naytaSsoLogin) {
        <div class="red-text common-error" style="vertical-align: middle">{{ commonError }}</div>
        <div style="padding: 2em; text-align: justify">
          <h3>Istunto on päättynyt</h3>
          <p>Microsoft-kirjautumisesi on edelleen voimassa. Voit halutessasi kirjautua ulos Microsoft-tililtäsi <a href="https://myaccount.microsoft.com/" target="_blank" rel="noopener">tästä</a>.</p>
        </div>
        <div style="padding-bottom: 2em; text-align: center">
          <button class="primarybutton" mat-button type="button" (click)="naytaSsoLogin = true">Kirjaudu</button>
        </div>
      }
      @if (naytaSsoLogin) {
        <app-sso-login [autoStart]="true" (cancel)="peruuta()"></app-sso-login>
      }
    </div>
  </div>

  <span class="disclaimer">© TILITOIMISTO LEMON TREE OY {{ getYear() }}</span>
</div>
